import { customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import {
  M8PagedResponse,
  M8PaginationParams,
  M8Promocode,
  M8PromocodeSortableField,
} from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = M8PaginationParams<M8PromocodeSortableField>;

export const getPromocodes = async (
  params: Params
): Promise<M8PagedResponse<M8Promocode>> => {
  const fetchURL = getM8AdminURL(`getPromocodes?${createQueryString(params)}`);

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
